import type { IconSvgObject } from './types';

const GitPullRequestClosedIcon: IconSvgObject = [
  ["path", { d: "M6 8.02344L6 16.0234", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 11.5234L18 16.0234", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "6", cy: "18.0234", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "6", cy: "6.02344", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["circle", { cx: "18", cy: "18.0234", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M20 4.02344L18 6.02344M18 6.02344L16 8.02344M18 6.02344L20 8.02344M18 6.02344L16 4.02344", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default GitPullRequestClosedIcon;
